import { Form, Input, Select } from "antd";
export const isWhiteSpace = {
  value: new RegExp("/^[^s].*$/", "ig"),
  message: "Enter a title can't start with blank",
};
const facultyArray = [
  {
    label: "Ebook",
    value: "Faculty_Ebook",
    key: "Faculty_Ebook",
  },
  {
    label: "Video",
    value: "Faculty_Video",
    key: "Faculty_Video",
  },
  {
    label: "Audio",
    value: "Audio",
    key: "Audio",
  },
  {
    label: "PPT",
    value: "Faculty_ppt",
    key: "Faculty_ppt",
  },
];
const studentContentArray = [
  {
    label: "Ebook",
    value: "Ebook",
    key: "Ebook",
  },
  {
    label: "Video",
    value: "Video",
    key: "Video",
  },
  {
    label: "Audio",
    value: "Audio",
    key: "Audio",
  },
];
export interface ChapterContentFilterInterface {
  isOpen: boolean;
  setIsOpen: any;
  inputTags: any;
  filterDataValue: any;
  setFilterDataValue: any;
  clearAllHandler: any;
  filterState: any;
  setFilterState: any;
  setSelectedChapter?: any;
  togglePane?: any;
  module: any;
}
const ChapterContentFilter = ({
  inputTags,
  filterState,
  setFilterState,
  module,
}: ChapterContentFilterInterface) => {
  const handleAddFilterArrayList = (name: string, val: any) => {
    setFilterState((prevState: any) => ({
      ...prevState,
      [name]: val,
    }));
  };
  // title
  console.log("filterStatefilterState", filterState);
  return (
    <div className="d-flex flex-column">
      <Form layout={"vertical"} className="w-100" size="large">
        <Form.Item label="Content Title">
          <Input
            style={{ width: "100%" }}
            value={filterState.title}
            name="title"
            placeholder="Content Title"
            onChange={(e: any) => {
              handleAddFilterArrayList("title", e.target.value);
            }}
          />
        </Form.Item>
        <Form.Item label="Content Type">
          <Select
            showSearch
            value={filterState.assetType}
            style={{ width: "100%" }}
            size="large"
            options={
              module === "studentContent" ? studentContentArray : facultyArray
            }
            onChange={(selected: any) => {
              handleAddFilterArrayList("assetType", selected);
            }}
          />
        </Form.Item>
        <Form.Item label="Content Tags">
          <Select
            showSearch
            value={filterState.tags}
            style={{ width: "100%" }}
            size="large"
            options={inputTags}
            onChange={(selected: any) => {
              handleAddFilterArrayList("tags", selected);
            }}
          />
        </Form.Item>
      </Form>
    </div>
  );
};
export default ChapterContentFilter;
